var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "waiveEfeeLogs",
      "centered": "",
      "size": "lg",
      "no-close-on-backdrop": "",
      "no-close-on-esc": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('h5', {
          staticClass: "modal-title"
        }, [_vm._v("Waive EFee Logs")]), _c('button', {
          staticClass: "close",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              _vm.$emit('onCloseModal') && (_vm.logData = []);
            }
          }
        }, [_c('span', {
          attrs: {
            "aria-hidden": "true"
          }
        }, [_vm._v("×")])])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.show,
      callback: function callback($$v) {
        _vm.show = $$v;
      },
      expression: "show"
    }
  }, [_c('div', {
    staticClass: "employerTable-card p-0 mt-0 mb-3 table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_vm.type == 'member' ? _c('th', [_vm._v("Member Id")]) : _vm._e(), _c('th', [_vm._v("Reason")]), _c('th', [_vm._v("User")]), _c('th', [_vm._v("Action From")]), _c('th', [_vm._v("Date")])])]), _vm.logData.length == 0 ? _c('tbody', [_c('tr', {
    staticClass: "text-center"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("No Records Found")])])]) : _vm._e(), _vm._l(_vm.logData, function (logs) {
    return _c('tbody', {
      key: logs.id
    }, [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.row.user_id))]), _c('td', [_vm._v(" " + _vm._s(logs.elgb_comment) + " ")]), _c('td', [_vm._v(_vm._s(logs.elgb_agent))]), _c('td', [_vm._v(_vm._s(logs.act_from || "NA"))]), _c('td', [_vm._v(_vm._s(logs.elgb_act_date))])])]);
  })], 2)]), _c('div', {
    staticClass: "d-flex justify-content-end align-items-center gap-2"
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }